/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import React from 'react';
import { Platform, useWindowDimensions, View } from 'react-native';
import { useDeviceInfo } from '@airasia-rn/ui/utils';
import ContentCardView from '@airasia-phoenix/react-native/widgets/ContentCardView';
import { ContentCardState } from '@airasia-phoenix/react-native/widgets/HorizontalContentCardView/ContentDetailsView';
import MasonryGrid from './MasonryGrid';
import recommendationCardStyles from './RecommendationCard.styles';

const SIDE_PADDING = 16;
const COLUMN_GAP = 12;
const NUM_COLUMNS = 2;
const SKELETON_COUNT = 6;

const skeletonItems = Array.from({ length: SKELETON_COUNT }, (_, i) => ({
  lobItemId: `skeleton-${i}`,
}));

const ForYouSkeltonLoadingView = () => {
  const deviceInfo = useDeviceInfo();
  const windowDimensions = useWindowDimensions();
  const windowWidth =
    Platform.OS === 'web' ? deviceInfo.width : windowDimensions.width;
  const cardSize = Math.floor(
    (windowWidth - SIDE_PADDING * 2 - COLUMN_GAP * (NUM_COLUMNS - 1)) /
      NUM_COLUMNS,
  );

  return (
    <MasonryGrid
      data={skeletonItems}
      renderItem={() => (
        <View style={recommendationCardStyles.cardContainer}>
          <ContentCardView
            contentCardState={ContentCardState.LOADING}
            imageWidth={cardSize}
            imageHeight={cardSize}
            image={{ uri: '' }}
          />
        </View>
      )}
    />
  );
};

export default ForYouSkeltonLoadingView;
